import { render } from "./index.vue?vue&type=template&id=b37b4c5a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=b37b4c5a&lang=scss"
import "./index.vue?vue&type=style&index=1&id=b37b4c5a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__